import { Message, MessageWithId } from 'shared/src/typings/messages/Message'

import { createAsyncAction } from 'typesafe-actions'

const CREATE_CONVERSATION_REQUEST = '@conversation/CREATE_CONVERSATION_REQUEST'
const CREATE_CONVERSATION_SUCCESS = '@conversation/CREATE_CONVERSATION_SUCCESS'
const CREATE_CONVERSATION_FAIL = '@conversation/CREATE_CONVERSATION_FAIL'
const CREATE_CONVERSATION_CANCEL = '@conversation/CREATE_CONVERSATION_CANCEL'

export const createConversationAsync = createAsyncAction(
  CREATE_CONVERSATION_REQUEST,
  CREATE_CONVERSATION_SUCCESS,
  CREATE_CONVERSATION_FAIL,
  CREATE_CONVERSATION_CANCEL
)<
  { endUserId: string; message: Message; tags?: number[] | string[] },
  MessageWithId,
  Error,
  undefined
>()
